module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_flow-4f3ffc92aed69a3861518765d5c7f2c4.png";